import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FsmTerritoryService {

  constructor() { }

  //Behavior Subject for Payment Term
  private type = new BehaviorSubject('');

  getType(): Observable<any> {
    return this.type.asObservable();
  }

  setType(term) {
    this.type.next(term);
  }
}
